import axios from 'axios';
import { CommonRootState } from '../combineReducers';
import { SafetyProgramRequirementStatus } from '../interfaces/safetyProgramRequirementStatus';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const { Incomplete, Rejected } = SafetyProgramRequirementStatus;

const fetchSafetyProgramsNotificationsCountSuccess = (payload: number) =>
  ({
    type: 'FETCH_SAFETY_PROGRAMS_COUNT_SUCCESS',
    payload
  } as const);

export const fetchSafetyProgramsNotificationsCount = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    const { data } = await axios.get<{ '@odata.count': number }>('/api/v3.01/safetyProgramRequirements', {
      params: {
        $top: 0,
        $filter: `(contractorId eq ${organizationId}) and ((status eq '${Incomplete}') or (status eq '${Rejected}'))`
      }
    });

    dispatch(fetchSafetyProgramsNotificationsCountSuccess(data['@odata.count']));
  } catch (error) {
    sendError(error);
  }
};

export type Actions = ReturnType<typeof fetchSafetyProgramsNotificationsCountSuccess>;
